import { CodeEvent } from 'domain/codeEvent/CodeEvent';

export interface RestCodeEvent {
  id: number;
  code: string;
  expired: boolean;
  eventId: number;
  consumerId?: number;
  expireDate?: Date;
}

export function toCodeEvent(restCodeEvent: RestCodeEvent) {
  return new CodeEvent(
    restCodeEvent.id,
    restCodeEvent.code,
    restCodeEvent.expired,
    restCodeEvent.eventId,
    restCodeEvent.consumerId,
    restCodeEvent.expireDate != null ? new Date(restCodeEvent.expireDate) : undefined,
  );
}
